import { types } from "../action-types";

const initialState = {
    loading: false,
    gigs: [],
    gigsCount:null,
    error: false,
    success: false,

};

const getCompanyGigsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_COMPANY_GIGS_INIT:
            return {
                ...state,
                loading: true,
                success: false,
            };

        case types.GET_COMPANY_GIGS_SUCCESS:
            return {
                ...state,
                loading: false,
                gigs: action.payload.Published,
                gigsCount:action.payload.PublishedCounts,
                error: false,
            };
        case types.GET_COMPANY_GIGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
            };
        
        default:
            return state;
    }
};

export default getCompanyGigsReducer;
